import { useCreditCardVerifications } from "@/hooks/firestore/user/useCreditCardVerifications";
import { BLOCKING_VERIFICATION_STATUSES } from "../utils/registry";

export const useBlockingCardVerification = () => {
  const { verifications, isLoading } = useCreditCardVerifications();

  const blocking = verifications.filter((entry) =>
    BLOCKING_VERIFICATION_STATUSES.includes(entry.status),
  );

  return {
    verification: blocking.at(0),
    blockingCount: blocking.length,
    isLoading,
  };
};
